import { render, staticRenderFns } from "./SearchPickUp.vue?vue&type=template&id=9b5a56da"
import script from "./SearchPickUp.vue?vue&type=script&lang=js"
export * from "./SearchPickUp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports